import React, { ReactElement } from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import cx from 'clsx';
import Typography from '@material-ui/core/Typography';
import { Certificates } from 'types/enums';
import { getIsSafari } from 'utilities/user-agent-util';

interface PrintCertificateProps {
  certificateType: string;
  firstName: string;
  lastName: string;
  onLoad: () => void;
}

const useStyles = makeStyles((theme: Theme) => {
  return {
    card: () => ({
      width: '97%',
      pageBreakAfter: 'always',
      breakAfter: 'always',
      pageBreakInside: 'avoid',
      display: 'block',
      margin: '0',
      padding: 0,
      borderWidth: 0,
      boxShadow: 'none',
      '&:last-child': {
        pageBreakAfter: 'avoid',
        breakAfter: 'avoid'
      }
    }),
    image: { maxWidth: '100%', width: '100%', height: 'auto', display: 'block' },
    titleContainer: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      justifyContent: 'center'
    },
    title: {
      color: theme.palette.grey[800],
      lineHeight: '100%'
    },
    titleDC: { margin: `-80% 0 ${theme.spacing(2.5)}px` },
    titleKWT: { margin: `-52% 0 ${theme.spacing(2.5)}px` }
  };
});

const PrintCertificate = ({
  firstName,
  lastName,
  certificateType,
  onLoad
}: PrintCertificateProps): ReactElement => {
  const classes = useStyles({ isSafari: getIsSafari() });

  return (
    <div className={classes.card}>
      {certificateType && (
        <img
          onLoad={onLoad}
          className={classes.image}
          {...(certificateType === Certificates.KWT && {
            src: '/images/KWTCompletionCertificate.png'
          })}
          {...(certificateType === Certificates.DC && {
            src: '/images/DigitalCitizenshipCertificate.png'
          })}
          alt={`Certificate ${firstName} ${lastName}`}
        />
      )}
      <div className={classes.titleContainer}>
        <Typography
          variant="h1"
          className={cx(
            classes.title,
            { [classes.titleDC]: certificateType === Certificates.DC },
            { [classes.titleKWT]: certificateType === Certificates.KWT }
          )}
        >
          {`${firstName} ${lastName}`}
        </Typography>
      </div>
    </div>
  );
};

export default PrintCertificate;
